export const errorMessages = {
  required: {
    id: 'text-this-field-is-required',
    defaultMessage: 'This field is required',
  },
  wrongOTPEntered: {
    id: 'text-wrong-otp-entered',
    defaultMessage: 'Wrong OTP entered',
  },
  somethingWentWrong: {
    id: 'text-something-went-wrong',
    defaultMessage: 'Something went wrong. Please try again later.',
  },
} as const;
